// extracted by mini-css-extract-plugin
export default {"paginateWrapper":"styles_paginateWrapper__4TVxb","loader":"styles_loader__jkVD6","container":"styles_container__uE3l+","active":"styles_active__azOpq","count":"styles_count__R0wGR"};